/* Vuex module - global */
import actions from './actions';
import mutations from './mutations';

import dictionaries from './dictionaries';

const INITIAL_STATE = {
  pendingAsyncStoreActions: [],
  lang: 'pl',
  stateSocketServer: false,
};

const getters = {
  pendingAsyncStoreActions: state => ({
    includes(pendingActions = []) {
      const _pendingActions = pendingActions;
      return state.pendingAsyncStoreActions.some(a => _pendingActions.includes(a));
    },
  }),
  lang: state => state.lang,
  stateSocketServer: state => state.stateSocketServer,
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
export default {
  namespaced: true,
  state: INITIAL_STATE,
  modules: {
    dictionaries,
  },
  mutations,
  actions,
  getters,
};
